const art = (props) => {
    return (
        <svg
            width="190px"
            height="122px"
            viewBox="0 0 263 170"
        >
            <g
                id="4"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <path
                    d="M261.27023,1.18207505 C260.920995,85.2667774 260.187898,162.560265 257.743531,165.520133 C202.444819,171.401385 2.06584877,167.834749 2.07671015,166.518427 C2.13760814,159.14241 0.66213166,16.3782029 0.790611554,0.785104171 L261.27023,1.18207505 Z"
                    id="2"
                    fill="#EDF4FF"
                ></path>
                <path
                    d="M0.791929338,0.785104171 L261.27023,1.18946506 L261.201813,16.7415789 L0.837788276,16.7415789 C0.816344117,11.4229134 0.760830666,6.10396096 0.791929338,0.785104171 Z"
                    id="1"
                    fill="#171F66"
                ></path>
                <path
                    d="M181.548061,82.4447101 C181.77082,121.294502 182.084239,157.00697 182.733604,158.378288 C197.32925,161.180808 250.178837,159.841591 250.173924,159.233368 C250.146485,155.82544 250.313809,89.8671929 250.255778,82.6626568 L181.548061,82.4447101 Z"
                    id="Fill-38-Copy-2"
                    fill="#CAE4FE"
                ></path>
                <path
                    d="M246.492614,86.1991748 C245.737663,87.2805544 242.276702,90.4785136 242.238509,90.440218 C242.024557,90.2255565 238.603178,86.8853032 238.095181,86.3207256 L246.492614,86.1991748 Z"
                    id="Fill-41-Copy-2"
                    fill="#FFFFFF"
                ></path>
                <path
                    d="M229.915269,137.783262 C256.168429,116.049605 215.450887,83.0895354 197.629645,110.984832 C194.970076,115.147783 194.209008,119.177168 194.638395,123.608563 C195.999327,137.653264 212.073726,148.825987 229.722546,137.927903 L229.915269,137.783262 Z"
                    id="Fill-42-Copy-2"
                    fill="#4F8EF9"
                ></path>
                <path
                    d="M229.997355,104.971498 C236.547366,110.169085 241.263767,119.45763 237.282571,127.989839 C235.502913,127.647714 233.779338,127.136355 232.019425,126.735566 C229.940623,126.307839 214.112064,123.660284 213.99313,122.493491 C214.424186,121.270568 216.140994,119.580589 217.032955,118.605179 C218.113283,117.423837 219.469394,115.998173 220.533314,114.887978 C223.691054,111.592966 226.980149,108.382617 229.997355,104.971498 Z"
                    id="Fill-43-Copy-2"
                    fill="#FFC100"
                ></path>
                <path
                    d="M229.802383,104.788363 C231.593629,106.254575 231.018661,105.934293 231.765547,106.665005 C225.496418,111.514178 219.621793,117.074953 214.143768,122.703084 L213.99313,121.957541 C214.083327,119.368086 214.769309,104.899225 216.10688,100.278417 C221.363074,100.317182 225.771501,102.041127 229.802383,104.788363 Z"
                    id="Fill-44-Copy-2"
                    fill="#FF8100"
                ></path>
                <path
                    d="M250.257176,23.3351697 C250.132031,49.7485793 249.908345,74.028796 249.26241,74.9595278 C234.67418,76.8285003 181.822183,75.7860732 181.825613,75.3726128 C181.844524,73.0555449 181.511359,28.2101543 181.551406,23.311892 L250.257176,23.3351697 Z"
                    id="Fill-37-Copy-2"
                    fill="#FFFFFF"
                ></path>
                <path
                    d="M246.492614,27.0663567 C245.737663,28.1478302 242.276702,31.3457893 242.238509,31.3074938 C242.024557,31.0927384 238.603178,27.7524851 238.095181,27.1880013 L246.492614,27.0663567 Z"
                    id="Fill-52-Copy-2"
                    fill="#CAE4FE"
                ></path>
                <g
                    id="3"
                    transform="translate(9.908374, 23.311892)"
                >
                    <path
                        d="M162.404992,52.2716401 C162.392292,25.918208 162.123925,1.69440214 160.608463,0.772587211 C126.175994,-0.937195987 1.34665145,0.664740214 1.35026675,1.07726202 C1.3701046,3.38897976 0.103263711,48.13835 0.144323659,53.025255 L162.404992,52.2716401 Z"
                        id="Fill-36-Copy-2"
                        fill="#FFFFFF"
                    ></path>
                    <path
                        d="M14.0493531,12.2182481 C20.834544,12.2456557 27.5680082,12.3602608 34.1726191,11.2633939"
                        id="Stroke-45-Copy-2"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M14.0493531,17.8366921 C46.9017465,17.762166 79.9196098,19.10786 112.757078,19.10786"
                        id="Stroke-46-Copy-2"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M14.0493531,25.6877338 C46.9017465,25.6132077 79.9196098,26.9589017 112.757078,26.9589017"
                        id="Stroke-46-Copy-2"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M14.0493531,33.5387755 C31.7759363,33.4642494 49.5918042,34.8099434 67.3103342,34.8099434"
                        id="Stroke-46-Copy-2"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M14.0493531,39.4218787 C37.4047968,40.3848051 60.6627199,40.3752312 84.0537604,40.375233"
                        id="Stroke-49-Copy-2"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M157.789073,5.63169696 C157.034122,6.7131705 153.57316,9.91112962 153.534968,9.87274022 C153.321016,9.6580787 149.899637,6.31782538 149.39164,5.75324775 L157.789073,5.63169696 Z"
                        id="Fill-53-Copy-2"
                        fill="#CAE4FE"
                    ></path>
                </g>
                <path
                    d="M172.316555,82.9600104 C172.207355,121.60556 171.850273,157.129272 170.331381,158.486511 C135.891682,161.118954 11.0646565,159.223606 11.069755,158.618668 C11.0981212,155.228668 9.99508161,89.6112322 10.0550586,82.4447101 L172.316555,82.9600104 Z"
                    id="Fill-39-Copy-2"
                    fill="#FFFFFF"
                ></path>
                <path
                    d="M40.6992719,146.349485 C40.8290967,137.775625 40.7389118,103.385121 40.966961,103.218798 C41.5399097,102.801154 54.4507566,102.544559 55.1067263,103.535147 C56.1883082,105.168499 56.352838,141.418114 56.352838,146.621098"
                    id="Fill-54-Copy-3"
                    fill="#4F8EF9"
                ></path>
                <path
                    d="M69.0208879,146.646175 C69.0208879,143.561686 68.7343926,127.424742 68.966275,127.351022 C69.5486509,127.165796 82.6719323,127.052057 83.3386954,127.491275 C84.4380736,128.215465 84.5292569,144.114969 84.5292569,146.421965"
                    id="Fill-55-Copy-3"
                    fill="#FF8700"
                ></path>
                <path
                    d="M126.939082,146.646175 C126.939082,144.116918 126.652587,130.884749 126.88447,130.824298 C127.466845,130.672414 140.590127,130.57915 141.25689,130.939305 C142.356268,131.533135 142.447452,144.570605 142.447452,146.462325"
                    id="Fill-55-Copy-5"
                    fill="#47B8C5"
                ></path>
                <path
                    d="M97.9799852,146.646175 C97.9799852,142.317219 97.6934899,119.66967 97.9253723,119.566206 C98.5077482,119.306249 111.63103,119.146622 112.297793,119.763046 C113.397171,120.779417 113.488354,143.093729 113.488354,146.331506"
                    id="Fill-55-Copy-4"
                    fill="#FFC100"
                ></path>
                <path
                    d="M21.1767215,95.5853364 C22.1163307,101.743222 21.9440937,146.134416 22.9690798,147.155818 C117.350643,147.155818 148.923074,148.048817 156.181403,147.155818"
                    id="Stroke-21-Copy"
                    stroke="#CAE4FE"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
                <path
                    d="M191.918976,33.6366698 C191.918976,36.4845477 191.527717,61.1727454 191.918976,67.5506338 C191.942521,67.9344475 233.981887,66.9057283 240.89899,66.9057283"
                    id="Stroke-50-Copy-2"
                    stroke="#CAE4FE"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
                <path
                    d="M238.716883,121.767107 C238.681943,123.868205 238.237262,125.994665 237.285148,128.076114 C235.540499,127.733989 233.85083,127.222631 232.125538,126.821841 C230.08763,126.394114 214.57045,123.746559 214.453856,122.579766 C214.48768,122.481878 214.52958,122.380999 214.578495,122.277732 C222.576902,121.508341 230.287364,121.688518 238.716883,121.767107 Z"
                    id="Combined-Shape"
                    fill="#47B8C5"
                ></path>
                <ellipse
                    id="Oval-2"
                    fill="#4F8EF9"
                    cx="203.10502"
                    cy="50.6392191"
                    rx="2.73937407"
                    ry="2.7478646"
                ></ellipse>
                <ellipse
                    id="Oval-2-Copy"
                    fill="#FF8100"
                    cx="213.279838"
                    cy="41.217969"
                    rx="2.73937407"
                    ry="2.7478646"
                ></ellipse>
                <ellipse
                    id="Oval-2-Copy-2"
                    fill="#FFC100"
                    cx="223.454656"
                    cy="59.2753649"
                    rx="2.73937407"
                    ry="2.7478646"
                ></ellipse>
                <ellipse
                    id="Oval-2-Copy-3"
                    fill="#47B8C5"
                    cx="233.629474"
                    cy="49.8541149"
                    rx="2.73937407"
                    ry="2.7478646"
                ></ellipse>
            </g>
        </svg>
    );
};
export default art;
